import React, {FC, useEffect, useId} from 'react'
import {createPortal} from 'react-dom'

import {useIsMountedRef} from '@progyny/hooks/useIsMountedRef'
import {usePortalStore} from '@progyny/store/portalStore'

const Container = () => {
  const setContainerNode = usePortalStore((state) => state.setContainerNode)
  return <div id='ov-portal' ref={setContainerNode} />
}

export {Container}

export type Props = {
  children?: React.ReactNode
  idPrefix?: string
  onPortalCreated?(): void
}

const noop = () => {}

const Portal: FC<Props> = ({
  children,
  idPrefix = '',
  onPortalCreated = noop,
}) => {
  const uniqueID = `portal-${useId()}`
  const isMounted = useIsMountedRef()
  const portalContainerRef = usePortalStore((state) => state.portalContainerRef)

  const portalId = idPrefix !== '' ? `${idPrefix}-${uniqueID}` : uniqueID

  useEffect(() => {
    if (isMounted) {
      onPortalCreated()
    }
  }, [onPortalCreated, isMounted])

  return portalContainerRef
    ? createPortal(
        <div data-portal-id={portalId}>{children}</div>,
        portalContainerRef
      )
    : null
}

export {Portal}
